import { useTheme } from "styled-components";
import { Bar } from "./progress-bar.styles";
import { useEffect, useState } from "react";

export type ProgressBarVariants = "default" | "success" | "error" | "info";

export interface ProgressBarInterface {
  variant: ProgressBarVariants;
  progress: number;
  animationTime?: number;
}

const ProgressBar = (props: ProgressBarInterface) => {
  const theme = useTheme();
  const [progress, setProgress] = useState(0);

  const colorMap: {
    [key in ProgressBarVariants]: string;
  } = {
    default: theme.colors.secondary50,
    error: theme.colors.error40,
    success: theme.colors.success40,
    info: "#0f81bd",
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      let progress = props.progress ?? 0;
      if (progress < 0) {
        console.warn("ProgressBar: progress should not be less than 0");
        progress = 0;
      } else if (progress > 100) {
        console.warn("ProgressBar: progress should not be greater than 100");
        progress = 100;
      }

      setProgress(progress);
    }, props.animationTime ?? 0);

    return () => clearTimeout(timeout);
  }, [props.progress, props.animationTime]);

  return (
    <Bar
      role="progressbar"
      value={progress}
      $color={props.variant ? colorMap[props.variant] : colorMap.default}
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      max={100}
    />
  );
};

export { ProgressBar };
